export default __webpack_public_path__ + "static/media/bathroom1-before-1440w.75f33535.png";